import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatSortModule } from '@angular/material/sort';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatIconModule } from '@angular/material/icon';

import { SharedTableComponent } from './components';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from '../pipes';

@NgModule({
  declarations: [
    SharedTableComponent,
  ],
  imports: [
    CommonModule,
    MatTableModule,
    MatSortModule,
    MatProgressSpinnerModule,
    MatPaginatorModule,
    MatIconModule,
    TranslateModule,
    PipesModule,
  ],
  exports: [
    SharedTableComponent,
  ]
})
export class SharedTableModule { }
